/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { toLower } from 'lodash';
import { HorseLink } from '../../../shared/links/ProfileLink';
import { formatDate } from '../../../utils/date';

const HorseCell = ({
    horseName,
    horseUid,
    horseSexCode,
    countryOriginCode,
    damSireStyleName,
    damSireUid,
    damSireCountryOriginCode,
    sireUid,
    horseDateOfBirth,
    sireStyleName,
    sireCountryOriginCode,
    isDamSire,
}) => {
    const horseYob = horseDateOfBirth ? formatDate(horseDateOfBirth, 'YYYY') : null;

    return (
        <div>
            <HorseLink
                className={
                (horseSexCode === 'M' || horseSexCode === 'F') ?
                    'hp-sire-progeny__female' :
                    ''
            }
                horseStyleName={horseName}
                horseUid={horseUid}
            />
            {isDamSire ? <span className="hp-sire-progeny__horseInfo">
                {countryOriginCode && ` (${countryOriginCode}) `}
                {horseYob}{toLower(horseSexCode)}
            </span> : <span className="hp-sire-progeny__country"> ({countryOriginCode})</span>}
            <div className="hidden-md-up">
                <HorseLink
                    className="ui-link_marked"
                    horseStyleName={isDamSire ? damSireStyleName : sireStyleName}
                    horseUid={isDamSire ? damSireUid : sireUid}
                />
                <span> ({isDamSire ? damSireCountryOriginCode : sireCountryOriginCode})</span>
            </div>
        </div>
    );
};

HorseCell.propTypes = {
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    horseSexCode: PropTypes.string,
    countryOriginCode: PropTypes.string,
    damSireStyleName: PropTypes.string,
    damSireUid: PropTypes.number,
    damSireCountryOriginCode: PropTypes.string,
    sireUid: PropTypes.number,
    horseDateOfBirth: PropTypes.number,
    sireStyleName: PropTypes.string,
    sireCountryOriginCode: PropTypes.string,
    isDamSire: PropTypes.bool,
};

export default HorseCell;



// WEBPACK FOOTER //
// ./src/js/horse/progeny/components/HorseCell.jsx